import React, { Component } from "react";
import classnames from "classnames";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { ITestableComponentProps } from "@formant/core/model/ITestableComponentProps";
import { Field, ITextTypeFieldProps } from "@formant/ui/component/common/Field";
import styles from "@formant/ui/component/common/FloatingLabel.module.scss";

import ClosedEye from "../../static/images/closed-eye.svg";
import OpenEye from "../../static/images/open-eye.svg";

type PasswordFieldProps = ITextTypeFieldProps<HTMLInputElement> &
    ITestableComponentProps;

@observer
export class PasswordField extends Component<PasswordFieldProps> {
    @observable
    private isFocused: boolean = false;
    @observable
    private isPasswordVisible: boolean = false;

    public render() {
        const {
            // <Field> props
            className,
            collapsed,
            errorMessage,
            icon,
            invalid,
            label,
            readOnly,
            small,

            // Component props
            id,
            disabled,
            value,
            onChange,
            autoComplete,
            placeholder,
            name,
        } = this.props;
        const { isFocused, isPasswordVisible } = this;

        return (
            <Field
                className={classnames(
                    className,
                    styles["floating-label-field"],
                    isFocused || (value && value.length > 0)
                        ? styles.focused
                        : null,
                    small ? styles.small : null,
                )}
                collapsed={collapsed}
                errorMessage={errorMessage}
                filledOut={value !== undefined && value.length > 0}
                icon={icon}
                invalid={invalid}
                label={
                    isFocused ? (label ?? placeholder) : (placeholder ?? label)
                }
                readOnly={readOnly}
                small={small}
            >
                <input
                    id={id}
                    type={isPasswordVisible ? "text" : "password"}
                    {...{
                        disabled,
                        readOnly,
                        value,
                        onChange,
                        onFocus: this.onInputFocus,
                        onBlur: this.onInputBlur,
                        autoComplete,
                        placeholder: undefined,
                        name,
                    }}
                    data-testid={this.props["data-testid"]}
                />
                <img
                    role="presentation"
                    src={isPasswordVisible ? OpenEye : ClosedEye}
                    onClick={this.onToggleShowPassword}
                />
            </Field>
        );
    }

    private onInputFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        const { onFocus } = this.props;
        this.isFocused = true;
        if (onFocus) {
            onFocus(event);
        }
    };

    private onInputBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        const { onBlur } = this.props;
        if (event.target.value.length === 0) {
            this.isFocused = false;
        }
        if (onBlur) {
            onBlur(event);
        }
    };

    private onToggleShowPassword = () => {
        this.isPasswordVisible = !this.isPasswordVisible;
    };
}
